var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.75 23.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 65") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.38,0H.38A.38.38,0,0,0,0,.38v23a.38.38,0,0,0,.38.37h23a.38.38,0,0,0,.37-.37V.38A.38.38,0,0,0,23.38,0ZM23,23H.75V.75H23ZM6,5.38A.38.38,0,0,1,6.38,5h14a.38.38,0,0,1,0,.75h-14A.38.38,0,0,1,6,5.38Zm-3,3A.38.38,0,0,1,3.38,8h17a.38.38,0,0,1,0,.75h-17A.38.38,0,0,1,3,8.38Zm0,3A.38.38,0,0,1,3.38,11h17a.38.38,0,0,1,0,.75h-17A.38.38,0,0,1,3,11.38Zm0,3A.38.38,0,0,1,3.38,14h17a.38.38,0,0,1,0,.75h-17A.38.38,0,0,1,3,14.38Zm0,3A.38.38,0,0,1,3.38,17h7a.38.38,0,0,1,0,.75h-7A.38.38,0,0,1,3,17.38Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.4d7346d8919245a5fff3f1bb7def9ea4.svg";
export { ForwardRef as ReactComponent };